export const SORT_OPTIONS: {
  labelKey: string;
  defaultLabel: string;
  value: 'ASC' | 'DESC' | null;
}[] = [
  {
    labelKey: 'page.datagrid.labels.sortAscending',
    defaultLabel: 'Ascending',
    value: 'ASC',
  },
  {
    labelKey: 'page.datagrid.labels.sortDescending',
    defaultLabel: 'Descending',
    value: 'DESC',
  },
  {labelKey: 'page.datagrid.contextMenu.clearSort', defaultLabel: 'Clear sort', value: null},
];
